import { http } from '../../../utils'

import { AxiosResponse } from 'axios'

export const ActionTypes = {
  GET_SITES_MONTHLY_RENT_DATA: 'GET_SITES_MONTHLY_RENT_DATA'
}

export const getSitesMonthlyData = (startDate?: string, endDate?: string) => {
  let url = '/charts/pvt/site_wise_monthly_rent'
  if(startDate && endDate) {
    url = `/charts/pvt/site_wise_monthly_rent?start_date=${startDate}&end_date=${endDate}`
  }
  return http
    .get(url)
    .then((response: AxiosResponse) => response)
}

export const getSitesMonthlyDataAction = (startDate?: string, endDate?: string) => ({
  type: ActionTypes.GET_SITES_MONTHLY_RENT_DATA,
  promise: getSitesMonthlyData(startDate, endDate),
})
